import { useInfiniteQuery } from '@tanstack/react-query';

const ScheduleSection = ({ classId, teacherId }) => {
	const API_URL = import.meta.env.VITE_API_URL;
	const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
		queryKey: ['scheduleList', { classId, teacherId }],
		queryFn: async ({ pageParam = 1 }) => {
			const params = new URLSearchParams();
		  	if (classId) params.append('cl_id', classId);
			if (teacherId) params.append('te_id', teacherId);
			params.append('page', pageParam);

			const res = await fetch(`${API_URL}/bbs/ajax.get_schedule_list.php?${params.toString()}`);
			return res.json();
		},
		getNextPageParam: (lastPage) => {
			const currentPage = lastPage.data.pagination.page;
			const totalPage = lastPage.data.pagination.total_page;
			return currentPage < totalPage ? currentPage + 1 : undefined;
		}
	});
	const items = data?.pages.flatMap(page => page.data?.list ?? []) ?? [];

	const formatSchedule = (datetime) => {
		const date = new Date(datetime.replace(" ", "T"));
		const days = ["일", "월", "화", "수", "목", "금", "토"];
		const monthDay = `${date.getMonth() + 1}.${date.getDate()}`;
		const dayName = days[date.getDay()];
		const hours = date.getHours();
		const minutes = date.getMinutes().toString().padStart(2, "0");
		const period = hours >= 12 ? "오후" : "오전";
		const hour12 = hours % 12 || 12;
		return {
			monthDay,
			dayName,
			time: `${period} ${hour12}:${minutes}`,
		};
	};

	return (
		<div>
			<div className="flex flex-wrap gap-3">
				{items.length === 0 ? (
					<div className="text-gray-400 text-center py-4">
						예정 스케쥴이 없습니다.
					</div>
					) : (
					items.map((item) => {
						const { monthDay, dayName, time } = formatSchedule(item.start);
						return (
							<div key={item.id} className="text-gray-700 px-4 py-2 rounded-lg border border-[#eee] flex flex-col items-center text-center gap-1">
								<span>{monthDay} ({dayName})</span>
								<span>{time}</span>
							</div>
						);
					}))
				}
			</div>
			{hasNextPage && (
				<button onClick={() => fetchNextPage()} className="text-gray-700">
					더보기
				</button>
			)}
		</div>
	);
};

export default ScheduleSection;